import { Editor, Range, Transforms } from 'slate';
import type { Node } from 'slate';
import type { CustomElement } from '@app/components/contract-text-editor/editor-plugins/with-suggestions';

const DIRECTION = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
} as const;

export const withParagraph = (editor: Editor) => {
  const { deleteBackward, deleteForward } = editor;
  const deleteEmptyParagraphAboveTable = (
    unit: any,
    direction: (typeof DIRECTION)[keyof typeof DIRECTION],
  ) => {
    if (!editor.selection) {
      return;
    }

    const [match] = Editor.nodes(editor, {
      match: (n: Node): boolean => {
        const isCollapsed = Range.isCollapsed(editor.selection!);
        const isStart = Editor.isStart(editor, editor.selection!.focus, []);

        return Boolean(
          (n as CustomElement).children?.length &&
            (n as CustomElement).children?.length !== 1 &&
            isCollapsed &&
            isStart,
        );
      },
      mode: 'lowest',
    });

    if (!match) {
      if (direction === DIRECTION.FORWARD) {
        deleteForward(unit);
      } else {
        deleteBackward(unit);
      }
      return;
    }

    // Get the current paragraph's path from the selection
    const [, currentPath] = Editor.parent(editor, editor.selection!.focus.path);
    Transforms.removeNodes(editor, {
      at: currentPath,
    });
    return;
  };

  editor.deleteBackward = (unit) => {
    deleteEmptyParagraphAboveTable(unit, DIRECTION.BACKWARD);
  };

  editor.deleteForward = (unit) => {
    deleteEmptyParagraphAboveTable(unit, DIRECTION.FORWARD);
  };

  return editor;
};
